import { TRIAD_PROXY_ROUTE } from 'app-requests/apiConstants';
import { LogWarning } from 'utils/logging';
import { triadSuperFetch } from 'utils/superFetch';
import { TMS_EVENT_TYPES } from 'utils/analytics/EVENT_TYPES';

export async function logClickEvent(
  eventName: TMS_EVENT_TYPES,
  schoolCode: string
): Promise<void> {
  if (!Object.values(TMS_EVENT_TYPES).includes(eventName)) {
    LogWarning('logClickEvent: Invalid event name', {
      description: `Invalid event name: ${eventName}`,
    });
    return;
  }

  const [error] = await triadSuperFetch(`${TRIAD_PROXY_ROUTE}/logevent`, {
    method: 'POST',
    timeout: 3000,
    body: { schoolCode, eventName },
  });

  if (error) {
    LogWarning('Failed to log form link click through event', {
      description: `${eventName}: ${
        error instanceof Error ? error.message : String(error)
      }`,
    });
  }
}
